module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_8.5b5cede60d2d9343005b6901e8da47bc.png";